<template>
  <nav id="sidebar">
    <div class="sidebar-header">
      <img class="logo" src="/img/new-logo-white.svg" />
    </div>

    <ul class="list-unstyled components">
      <li>
        <router-link to="/dashboard">
          <font-awesome-icon icon="network-wired" />
          <span>Products</span>
        </router-link>
      </li>
      <li v-show="false">
        <router-link to="/billing">
          <font-awesome-icon icon="credit-card" />
          <span>Billing</span>
        </router-link>
      </li>
      <li v-show="false">
        <router-link to="/account">
          <font-awesome-icon icon="user" />
          <span>Account</span>
        </router-link>
      </li>
    </ul>

    <a id="logout" @click="logOff">
      <font-awesome-icon icon="sign-out-alt" />
      <span>Log out</span>
    </a>
  </nav>
</template>

<script type="text/javascript">
export default {
  name: 'SideBar',
  methods: {
    logOff() {
      this.$emit('logged-off')
      this.$store.dispatch('logout').then(() => {
        this.$router.push({ name: 'login' })
      })
    }
  }
}
</script>

<style scoped></style>
